import { buildApiUrl } from '../config/api.js';

class SeasonModelService {
  constructor() {
    this.authenticatedFetch = null;
  }

  // Método para establecer la función de fetch autenticada
  setAuthenticatedFetch(fetchFn) {
    this.authenticatedFetch = fetchFn;
  }

  // Obtener modelos asignados a una temporada
  async getSeasonModels(seasonId) {
    try {
      const url = buildApiUrl(`/api/admin/season-models/season/${seasonId}`);
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        : await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
          });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al obtener modelos de la temporada:', error);
      throw error;
    }
  }

  // Obtener temporadas asignadas a un modelo
  async getModelSeasons(vehicleModelId) {
    try {
      const url = buildApiUrl(`/api/admin/season-models/model/${vehicleModelId}`);
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        : await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
          });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al obtener temporadas del modelo:', error);
      throw error;
    }
  }

  // Obtener modelos disponibles para asignar a una temporada
  async getAvailableModelsForSeason(seasonId) {
    try {
      const url = buildApiUrl(`/api/admin/season-models/available/${seasonId}`);
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        : await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
          });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al obtener modelos disponibles:', error);
      throw error;
    }
  }

  // Asignar modelo a temporada
  async assignModelToSeason(seasonId, vehicleModelId) {
    try {
      const url = buildApiUrl('/api/admin/season-models/assign');
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ seasonId, vehicleModelId })
          })
        : await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify({ seasonId, vehicleModelId })
          });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al asignar modelo a temporada:', error);
      throw error;
    }
  }

  // Asignar múltiples modelos a una temporada
  async assignMultipleModelsToSeason(seasonId, vehicleModelIds) {
    try {
      const url = buildApiUrl('/api/admin/season-models/assign-multiple');
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ seasonId, vehicleModelIds })
          })
        : await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify({ seasonId, vehicleModelIds })
          });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al asignar múltiples modelos:', error);
      throw error;
    }
  }

  // Desasignar modelo de temporada
  async unassignModelFromSeason(seasonId, vehicleModelId) {
    try {
      const url = buildApiUrl(`/api/admin/season-models/unassign/${seasonId}/${vehicleModelId}`);
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        : await fetch(url, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
          });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al desasignar modelo de temporada:', error);
      throw error;
    }
  }
}

export default new SeasonModelService();
